import { render, staticRenderFns } from "./filtri.vue?vue&type=template&id=9d00daec"
import script from "./filtri.vue?vue&type=script&lang=js"
export * from "./filtri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports